import{__module as e}from"../../../../_virtual/taggedTemplateLiteral.js";var r;(r=e).exports=function(e,r){return r||(r=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))},r.exports.__esModule=!0,r.exports.default=r.exports;
//# sourceMappingURL=taggedTemplateLiteral.js.map
